module.exports = __webpack_public_path__ + "static/media/meal_unselected.b73cc6ca.svg";